<template>
  <div style="display: flex; justify-content: space-between">
    <div class="graph_frame">
      <div class="chart_paragraph">
        RÉPARTITION DES ASSURÉS SELON LE TYPE DE PERSONNE
      </div>
      <Pie
        v-if="chart.types"
        :graph_data="json_data_advanced.types"
        :timestamp="timestamp"
        :event_name="'types_event'"
        :translate_key="'family'"
      />
    </div>

    <div class="graph_frame">
      <div class="chart_paragraph">
        RÉPARTITION DES ASSURÉS PRINCIPAUX SELON LA COMPOSITION FAMILIALE
      </div>
      <Pie
        v-if="chart.family"
        :graph_data="json_data_advanced.family"
        :timestamp="timestamp"
        :event_name="'family_event'"
        :translate_key="'composition_family'"
      />
    </div>
  </div>

  <div style="display: flex; justify-content: space-between">
    <div class="graph_frame">
      <div class="chart_paragraph">
        RÉPARTITION DES ASSURÉS PRINCIPAUX SELON LA {{ sousCategory }} CATEGORIE
      </div>
      <Pie
        v-if="chart.categories && category === 'all'"
        :graph_data="json_data_advanced.categories"
        :timestamp="timestamp"
        :event_name="'categories_event'"
        :translate_key="'category'"
      />
      <Pie
        v-if="chart.categories && category === 'ac'"
        :graph_data="json_data_advanced.categories"
        :timestamp="timestamp"
        :event_name="'categories_event_ac'"
        :translate_key="'category'"
      />
      <Pie
        v-if="chart.categories && category === 'in'"
        :graph_data="json_data_advanced.categories"
        :timestamp="timestamp"
        :event_name="'categories_event_in'"
        :translate_key="'category'"
      />
    </div>

    <div class="graph_frame">
      <div class="chart_paragraph">
        RÉPARTITION DES ASSURÉS PRINCIPAUX SELON LE COLLEGE
      </div>
      <Pie
        v-if="chart.colleges"
        :graph_data="json_data_advanced.colleges"
        :timestamp="timestamp"
        :event_name="'college_event'"
        :translate_key="'college'"
      />
    </div>
  </div>

  <div style="display: flex; justify-content: space-between">
    <div class="graph_frame" style="width: 100%">
      <div class="chart_paragraph" style="height: 38px">
        PYRAMIDE DES AGES DES ASSURÉS PRINCIPAUX
      </div>
      <Pyramide
        v-if="chart.age_sex"
        :graph_data="json_data_advanced.age_sex"
        :timestamp="timestamp"
      />
    </div>

    <div class="graph_frame" v-if="false">
      <div class="chart_paragraph">
        RÉPARTITION DES ASSURÉS PRINCIPAUX SELON LE GENRE
      </div>
      <Pie
        v-if="chart.sex && false"
        :graph_data="json_data_advanced.sex"
        :timestamp="timestamp"
        :event_name="'sex_event'"
        :translate_key="'genre'"
      />
    </div>
  </div>
</template>

<script>
import Pie from "./Pie.vue";
import Pyramide from "./Pyramide.vue";

export default {
  components: { Pie, Pyramide },
  props: {
    timestamp: {
      type: Number,
      required: true,
    },
    json_data_advanced: {
      type: Object,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chart: {
        types: false,
        family: false,
        categories: false,
        colleges: false,
        age_sex: false,
        sex: false,
      },
    };
  },
  computed: {
    sousCategory(){
      return this.category === 'all' ? '' : 'SOUS';
    }
  },
  mounted() {
    Object.keys(this.chart).forEach((key, i) => {
      setTimeout(() => {
        this.chart[key] = true;
      }, i * 500);
    });
  },
};
</script>

<style scoped>
.graph_frame {
  background-color: white;
  margin-bottom: 22px;
  border-radius: 10px;
  box-shadow: 0 0 3px 0 #ccc;
  width: 538px;
  height: 320px;
}
.chart_paragraph {
  width: 538px;
  height: 60px;
  border-bottom: 1px solid #f1f1f1;
  padding: 10px 16px;
  font-weight: bold;
  color: darkslategray;
  vertical-align: middle;
}
</style>